<template>
  <div>
    <!-- <p>Chart type: {{ chartType }}</p> -->
    <div v-if="chartType == 'RADIO'" class="vertical-chart">
      <div v-for="(value, index) in dataValuesPercent" class="vertical-chart__row">
        <div class="vertical-chart__label">
          {{ chartLabels[index]}}
        </div>
        <div class="vertical-chart__bar-container">
          <span class="radio-field__icon" v-if="options[index].icon">
            <img class="radio-field__icon__icon" v-if="options[index].icon" :src="options[index].icon">
          </span>
          <div class="vertical-chart__bar-container">
            <div class="vertical-chart__bar-wrapper" v-bind:style="{ width: chartBarHeights[index] + '%' }">
              <div class="vertical-chart__bar"></div>
              <span class="vertical-chart__value">{{ value }}%</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-else>
      <div
        class="chart-bars"
        v-bind:style="{ height: chartHeight + 'px' }"
      >
        <div
          v-for="(value, index) in dataValuesPercent"
          v-bind:key="index"
          :class="'chart-bars__bar chart-bars__bar--' + index"
          v-bind:style="{ height: chartBarHeights[index] + '%'}"
        ><span class="chart-bars__bar__value">{{value}}%</span></div>
      </div>
      <div class="chart-labels" v-if="chartType == 'RATING'">
        <div
          v-for="(label, index) in chartLabels"
          v-bind:key="index"
          class="chart-labels__label"
        >
          <star :text="label" :starId="index + 1" :class="'star--' + index"></star>
        </div>
      </div>
      <div class="chart-labels" v-if="chartType == 'YESNO'">
        <div
          v-for="(label, index) in chartLabels"
          v-bind:key="index"
          class="chart-labels__label chart-labels__label--yesno"
        >
          <!-- <img v-if="index === 0" src="yes_icon_light_grey.svg">
          <img v-if="index === 1" src="no_icon_light_grey.svg"> -->
          <div v-if="index === 0" class="thumb-up svg-container"><Thumb/></div>
          <div v-if="index === 1" class="thumb-down svg-container"><Thumb/></div>
          <p class="chart-label__text">{{ label }}</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

  import Star from './StarLabel.vue' 
  import Thumb from '../assets/thumb.svg'

  export default {
    components: {
      Star,
      Thumb
    },
    props: {
      chartLabels: Array,
      dataValues: Array,
      chartType: String,
      options: Array,
    },
    data: function () {
      return {
        chartHeight: 180,
        chartBarHeights: [0,0,0,0]
      }
    },
    computed: {
      dataValuesPercent() {
        let sumValues = 0;
        let valuesToPercent = [];

        for (var i = 0; i < this.dataValues.length; i++) {
          sumValues += this.dataValues[i];
        }

        for (var i = 0; i < this.dataValues.length; i++) {
          let value = 0;
          if (this.dataValues[i] > 0) {
            value = (this.dataValues[i] / sumValues) * 100;
            value = Math.round(value);
          }
          valuesToPercent.push(value);
        }

        return valuesToPercent;
      },
      updateChartBarHeights() {
        // Calculate bar height based on heighest bar
        let arr = [];
        let heighestValue = 1;
        for (var i = 0; i < this.dataValuesPercent.length; i++) {
          if ( this.dataValuesPercent[i] > heighestValue ) {
            heighestValue = this.dataValuesPercent[i];
          }
        }
        let multiplyRatio = 100 / heighestValue;
        for (var i = 0; i < this.dataValuesPercent.length; i++) {
          arr.push(this.dataValuesPercent[i] * multiplyRatio );
        }
        let zeroes = [0,0,0,0];
        return arr;
      }
    },
    mounted: function () {
      
      setTimeout(() => {
        this.chartBarHeights = this.updateChartBarHeights;
      }, 1000);
    }
  }


</script>